var _RegisterStreamCommand_platform, _RegisterStreamCommand_keyId;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import Axios from 'axios';
export class RegisterStreamCommand {
    constructor(pf, keyId) {
        _RegisterStreamCommand_platform.set(this, void 0);
        _RegisterStreamCommand_keyId.set(this, void 0);
        __classPrivateFieldSet(this, _RegisterStreamCommand_platform, pf, "f");
        __classPrivateFieldSet(this, _RegisterStreamCommand_keyId, keyId, "f");
    }
    async execute() {
        const host = 'https://mycast.xyz:9011';
        const url = `${host}/stream`;
        try {
            const param = new URLSearchParams();
            param.append('platform', __classPrivateFieldGet(this, _RegisterStreamCommand_platform, "f"));
            param.append('keyId', __classPrivateFieldGet(this, _RegisterStreamCommand_keyId, "f"));
            const { data } = await Axios.post(url, param.toString());
            if (!data || !data.result) {
                return false;
            }
            return true;
        }
        catch (e) {
            console.error('unknown error', e);
            return false;
        }
    }
}
_RegisterStreamCommand_platform = new WeakMap(), _RegisterStreamCommand_keyId = new WeakMap();
